import React from 'react';
import { classIf } from '../../data/utils';
import {ReactComponent as PinIcon} from '../../icons/pin.svg';
import { useFavoriteTournaments, useFavoriteTournamentsDispatch } from './FavoriteTournamentsProvider';

export default function FavoriteTournamentToggle(props) {
    const favoriteTournaments = useFavoriteTournaments();
    const favoriteTournamentsDispatch = useFavoriteTournamentsDispatch();

    function toggleFavorite(e) {
        e.stopPropagation();
        e.preventDefault();
        favoriteTournamentsDispatch({type: 'toggle', id: props.uniqueId});
    }
    
    const className = props.className;
    const selected = favoriteTournaments[props.uniqueId];

    return (
        <div className={"pin-toggle" + classIf(className != null, className)} onClick={toggleFavorite}>
            <PinIcon className={"pin-toggle" + classIf(selected === true, 'selected')}></PinIcon>
        </div>
    );
}
